// 酒店名称常量
const MOTEL_NAME = '';

export const zhMessage = {
  // 头部导航
  hello: '你好',
  lang_text: '中文',
  motelName: MOTEL_NAME,
  menuHome: '首页',
  // menuOrder: '订单',
  // menuMember: '会员',
  // menuActivity: '活动',
  // menuMe: '我的',
  // menuLogin: '登录',
  menuMembership: '会员中心',
  accommodation: '住宿',
  // 页尾部分：
  findUsOn: '关注我们',
  requestMap: '索取地图',
  reportProblem: '问题反馈',
  help: '帮助',
  faqs: '常见问题解答',
  about: '关于星田旅业',
  terms: '使用条款',
  privacy: '隐私政策',
  location: '位置',
  contactUs: '联系我们',
  // 登陆对话框
  loginModal: {
    titleLogin: '登录',
    titleRegister: '注册',
    inputEmail: '邮箱',
    inputPassword: '密码',
    inputConfirmPassword: '确认密码',
    submitButton: '确认',
    emailPlaceholder: '请输入邮箱',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请再次输入密码',

    emailRequiredValidate: '邮箱不能为空',
    emailTypeValidate: '邮箱格式不正确',
    passwordRequiredValidate: '密码不能为空',
    passwordLengthValidate: '密码长度不能小于6个',
    confirmPasswordSomeValidate: '两次密码输入不一致',

    confirmButton: '确认',
  },

  // 首页
  home: {
    title: MOTEL_NAME,
    beginTravel: '开始订房',
    checkinDate: '入住日期',
    checkoutDate: '离店日期',
    search: '搜索',
    activityShow: '享住新西兰',
    redeemProduct: '积分兑换',
    searchError: '入住和离店日期不能为空！',
  },

  // 房间搜索结果
  roomList: {
    title: MOTEL_NAME + ' - 房间查询结果',
    roomCapacity: '可入住人数',
    checkin: '入住日期',
    checkout: '离店日期',
    marketPirce: '门市价',
    memberPrice: '会员价',
    oneNight: '起 每晚',
    startingAt: '',
    totalPrice: '小计',
    cancelLimit: '限时取消',
    orderDesc: '包含所有税费和手续费，地方税（如有）除外',
    detailButton: '查看详细信息',
  },

  // 订单提交页面
  bookRoom: {
    title: MOTEL_NAME + ' - 提交订单',
    loginDesc: {
      loginOrRegister: '登录或注册',
      loginDesc1: '在' + MOTEL_NAME + '上预定',
      loginDesc2: '即可享受快速便捷的结账退房服务。',
    },

    mainGuest: '主要客人',
    guestNameDesc: '请输入您在护照证件上的全名。',
    guestPoptipTitle: '如何添加住客',
    guestPoptipContent1: '1. 请输入您在护照证件上的全名。',
    guestPoptipContent2: '2. 未满18岁的住客必须在成人的陪同下入住。',

    firstName: '名字',
    lastName: '姓氏',
    firstNamePlaceholder: '请使用拼音输入名字',
    lastNamePlaceholder: '请输用拼音输入姓氏',
    guestsNumber: '客人数量',

    bookingContact: '预定联系人',
    email: '电子邮件',
    emailPlaceholder: '请输入预定联系人的电子邮件地址',
    emailDesc: '我们会将您的预订确认信息发送至此电子邮件地址，请确保地址正确无误。',

    registerCheckbox: '注册以获取积分和额外服务',
    createPassword: '创建密码',
    confirmPassword: '确认密码',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请再次输入密码',

    phoneNumber: '电话号码',
    regionPlaceholder: '请选择或输入查询国家/地区',
    phonePlaceholder: '请输入联系人的电话号码',

    couponWay: '优惠方式',
    chooseCoupon: '选择优惠',
    couponPlaceholder: '点击选择更多优惠券',

    privacyPolicy1: '继续即表示您同意我们的',
    privacyPolicy2: '服务条款',
    privacyPolicy3: '和',
    privacyPolicy4: '隐私信息。',

    bookButton: '预订',

    checkinDate: '入住',
    checkoutDate: '退房',
    guests: '客人',
    stay: '入住',

    confirmCheckin: '办理入住时确认',
    mealNotIncluded: '不含餐食',
    maxGuests1: '最多入住',
    maxGuests2: '位客人',
    payUpfront: '提前付款',
    cancellation1: '在',
    cancellation2: '之前取消可免费退房',
    noRefundable: '不可退款',

    taxesAndFees: '税费和手续费',
    tax1: '增值税',
    total: '总计',

    freeCancellation: '免费退房',
    freeCancellationDesc1: '在',
    freeCancellationDesc2: '（新西兰本地时间）之前取消可免费退房，之后则不可取消房间。',
    instantConfirmation: '即时确认',

    notNoneValidate: '不能为空',
    englishNameValidate: '姓名必须用英文字母填写',
    emailValidate: '邮箱格式不正确',
    passwordLengthValidate: '密码长度不能少于6位',
    confirmPasswordValidate: '两次密码输入不一致',

    hopeRegisterModalTitle: '注册有积分',
    hopeRegisterModalContent1: '我们注意到您之前有在本站订房，如果您现在注册，可获得',
    hopeRegisterModalContent2: '积分，是否需要？',

    chooseGuestTitle: '选择常住人',
  },

  // 订单列表页
  order: {
    title: MOTEL_NAME + ' - 订单列表',

    // 登录后界面
    headerTitle: '订单列表',
    headerTabALL: '全部',
    headerTabNoCheckin: '未入住',
    headerTabCheckin: '已入住',
    headerTabCancelled: '已取消',

    orderNumber: '订单编码',
    check_in: '入住',
    check_out: '离店',
    orderDetail: '订单详情',
    noOrders: '没有订单',

    // 未登录的界面
    orderQueryTitle: '订单查询',
    orderQueryInputPlaceholder: '请输入订单编码',
    orderQueryButton: '查询',
    orderQueryDes: '输入订单编码点击查询后，订单信息将发送到您的邮箱中，请前往查收。',
    orderQueryInputValidate: '订单编码不能为空',
    sendModalText: '订单信息邮件发送成功，请您登录邮箱查看。',
  },

  // 订单详情页
  orderDetail: {
    title: MOTEL_NAME + ' - 订单详情',

    headerTitle: '订单详情',
    payButton: '支付',
    cancelButton: '取消',

    roomDetailTitle: '客房详情',
    roomName: '客房名称',
    roomType: '客房类型',
    stay: '晚数',
    totalMoney: '合计',
    orderStatus: '订单状态',
    GuestInfo: '客人信息',
    guestName: '主要客人姓名',
    checkin: '入住日期',
    checkout: '离店日期',
    phone: '联系电话',
    orderId: '订单编码',
    orderInfo: '订单信息',
    orderCreateTime: '下单时间',

    payModal: {
      title: '在线支付',
      content: '支付金额',
      button: '支付',
    }
  },

  // 会员页面
  member: {
    title: MOTEL_NAME + ' - 会员',

    memberCardName: '星田旅业会员',
    greeting: '您好，星田旅业会员',
    score: '积分',
    coupons: '优惠券',
    joinUs: '加入会员',
    scoreRedeem: '积分兑换',
    memberActivity: '会员活动',
    benefit: '会员权益',
    getIt: '去兑换',
  },

  // 我的页面
  me: {
    title: MOTEL_NAME + ' - 账号信息',

    profile: '账号信息',
    name: '名称',
    memberName: '星田旅业会员',
    memberRank: '会员等级',
    email: '邮箱',
    cardName: '星田旅业会员',

    score: '积分',
    redeem: '积分兑换',
    orders: '订单',
    seeOrders: '查看订单',
    myCoupons: '我的优惠券',
    seeCoupons: '查看优惠券',

    editGuests: '编辑常住人',
    advices: '建议和意见',
    changePassword: '修改密码',
    logout: '退出登录',

    logoutModalText: '是否退出登录？',
  },

  // 活动页面
  activity: {
    title: MOTEL_NAME + ' - 活动信息',

    activityBannerName: '享住新西兰',

    activityStartDate: '活动开始日期',
    activityEndDate: '活动结束日期',
  },

  // 优惠券列表页面
  couponList: {
    title: `${MOTEL_NAME} - 优惠券`,

    myCouponTitle: '我的优惠券',
    myScore: '我的积分',
    myCouponDes: '点击立即使用',
    buttonText: '立即使用',
    redeemableCouponTitle: '可兑换优惠券',
    redeemableCouponDes: '积分可兑换',
    redeemButton: '兑换',

    redeemModalTitle: '积分兑换优惠券',

  },

  // 选择优惠券页面
  chooseCoupon: {
    title: `${MOTEL_NAME} - 选择优惠券`,

    noCouponButton: '不使用优惠券',
  },

  // 积分兑换页面
  integral: {
    title: `${MOTEL_NAME} - 积分专区`,

    myProductTitle: '可领取礼品',
    myScore: '我的积分',
    productDesc: '前台展示领取',
    redeemableProductTitle: '积分兑换专区',

    redeemModalTitle: '积分兑换礼品',

  },

  // 意见和建议页面
  feedback: {
    title: `${MOTEL_NAME} - 意见和建议`,

    headerTitle: '意见类型',
    feedbackData: [
      {
        title: '网页使用',
        showTypes: '登录 卡顿 闪退',
        reasons: ['闪退', '无法登录', '卡顿', '界面混乱', '其他'],
      },
      {
        title: '入住体验',
        showTypes: '服务 卫生 设施 餐饮',
        reasons: ['服务不好', '卫生差', '设备不完善'],
      },
      {
        title: '预定流程',
        showTypes: '服务 卫生 设施 餐饮',
        reasons: ['预订不成功', '支付不成功', '无法自助选房', '订单无法取消', '其他'],
      },
      {
        title: '会员政策',
        showTypes: '会员等级 权益 积分',
        reasons: ['积分未到账', '会员升级问题', '无法享受会员权益', '会员资料无法修改', '其他'],
      },
      {
        title: '优惠促销',
        showTypes: '优惠券 红包 折扣房价',
        reasons: ['无法使用优惠券', '无法参加活动', '其他'],
      },
      {
        title: '其他问题',
        showTypes: '其他问题',
        reasons: ['其他问题'],
      },
    ],

    // 提交反馈页面部分
    submitHeaderTitle: '意见建议',
    feedbackReason: '反馈原因',
    feedbackReasonPlaceholder: '请选择反馈原因',
    feedbackContentPlaceholder: '请填写您保贵的意见',
    submitButton: '确定',
    resetButton: '重置',
    feedbackReasonRequired: '请选择反馈原因',
    feedbackContentRequired: '请输入反馈意见'
  },

  // --- 组件部分 --- start
  // 侧边栏
  sideBar: {
    memberName: '星田旅业会员',
    memberId: '会员ID',
    myAccount: '我的账号',
    logout: '退出登录',

    logoutModalText: '是否退出登录？',

    coupons: '优惠券',
    scoreGift: '礼品兑换',
    guests: '常住人',
    advice: '建议和意见',
    changePassword: '修改密码',
    loginButton: '登录',
  },
  // 修改密码
  changePassword: {
    title: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    submitButton: '确认',
    resetButton: '重置',

    oldPasswordValidate: '旧密码不能为空',
    newPasswordEmptyValidate: '新密码不能为空',
    newPasswordLengthValidate: '新密码长度不能少于6位',
    confirmPasswordValidate: '确认密码不能为空',
    confirmPasswordSomeValidate: '两次密码输入不一致！',
  },
  // 编辑常住人
  editGuest: {
    title: '常住人',
    addButton: '添加',

    editGuest: '编辑常住人',
    firstName: '名',
    firstNamePlaceholder: '请用拼音填写常住人名',
    lastName: '姓',
    lastNamePlaceholder: '请用拼音填写常住人姓',
    okButton: '确定',
    resetButton: '重置',

    deleteGuest: '删除常住人',
    deleteText: '是否删除该常住人？',
  },
  // --- 组件部分 --- end
}
